import { Suspense, useContext } from 'react';
import { createHashRouter, Navigate, RouterProvider } from 'react-router-dom';
import { LoginSelect } from 'src/features/login';

import { AuthDataProvider } from '../authProvider';
import { ProgressBox } from '../progress';
import { getRouterWithRoles } from './Routes.helper';

export const Routes = () => {
  const { isLoading, isAuthenticated, environment, userRole } =
    useContext(AuthDataProvider);

  if (isLoading) return <ProgressBox loading />;

  const router = createHashRouter([
    {
      path: '/login-select',
      element: isAuthenticated ? (
        <Navigate to={'/#/home'} replace />
      ) : (
        <LoginSelect environment={environment} />
      ),
    },

    // only mount when authenticated; otherwise bounce to /login-select
    ...(isAuthenticated
      ? getRouterWithRoles(userRole)
      : [
          {
            path: '/*',
            element: <Navigate to="/login-select" replace />,
          },
        ]),
  ]);

  return (
    <Suspense fallback={<ProgressBox loading />}>
      <RouterProvider router={router} />
    </Suspense>
  );
};
